import PropTypes from 'prop-types';
import React from 'react';
import { IMAGE_CDN_URL } from '../../../../utilities/imageCDN';
import './CompanyIcon.scss';

const DEFAULT_ICON = `${IMAGE_CDN_URL}/v1528477802/icons/company_2x.png`;

export default class CompanyIcon extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
         * Company logo image
         * */
        logo: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        /**
         *  additional classes (eg isSticky)
         */
        classes: PropTypes.string,
    };
    static defaultProps = {
        logo: null,
        classes: '',
    };

    render() {
        let imgSrc =
            this.props.logo && this.props.logo.src
                ? this.props.logo.src
                : DEFAULT_ICON;

        return (
            <div
                className={`component-Layout-CompanyHeaderV2-CompanyIcon ${this.props.classes}`}
            >
                <div
                    style={{ backgroundImage: `url(${imgSrc})` }}
                    className="company-icon-image"
                ></div>
            </div>
        );
    }
}
